import { render, staticRenderFns } from "./v-search.vue?vue&type=template&id=d91f5dea&"
import script from "./v-search.vue?vue&type=script&lang=js&"
export * from "./v-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports